/**
 *  INIT HEADER
 */

import { resetOpenedDropdowns } from '../_01_atoms/dropdown-menu';
import user from './header/user';
import flashbags from './header/flashbags';
import modalUser from './user/modals/modal-user';

export default function () {
  if (document.querySelector('#flashbags')) {
    flashbags();
  }

  user();

  if (document.querySelector('#search-app') && document.querySelector('.modal-user')) {
    modalUser('.modal-user');
  }

  const dropdown = document.querySelector('.location-dropdown-container');
  const button = document.querySelector('.location-dropdown--button');

  if (!dropdown || !button) {
    return;
  }

  const toggleDropdown = (event) => {
    event.stopPropagation();
    const isOpen = dropdown.classList.toggle('show');
    button.classList.toggle('open', isOpen);

    resetOpenedDropdowns();
  };

  button.addEventListener('click', toggleDropdown);

  document.addEventListener('click', (event) => {
    if (!dropdown.contains(event.target) && !button.contains(event.target)) {
      dropdown.classList.remove('show');
      button.classList.remove('open');
    }
  });
}
